import React, {useEffect, useState} from 'react';
import { Link } from "react-router-dom";
import { useDispatch,useSelector } from 'react-redux';
import { addUrl } from '../histori/HistoriSlice';
import { motion } from 'framer-motion';


const PokemonCard = ({ name, src , color }) => {
    const dispatch = useDispatch();
    const [bgColor,setBgColor] = useState()



    useEffect(() => {
        if (Array.isArray(color) && color.length > 0) {
            const type = color[0].type.name;
            switch(type) {
                case "normal": setBgColor("bg-white"); break;
                case "fighting": setBgColor("bg-amber-700"); break;
                case "flying": setBgColor("bg-sky-400"); break;
                case "poison": setBgColor("bg-purple-700"); break;
                case "ground": setBgColor("bg-amber-500"); break;
                case "rock": setBgColor("bg-gray-600"); break;
                case "bug": setBgColor("bg-green-900"); break;
                case "ghost": setBgColor("bg-purple-950"); break;
                case "steel": setBgColor("bg-gray-500"); break;
                case "fire": setBgColor("bg-orange-400"); break;
                case "water": setBgColor("bg-blue-500"); break;
                case "grass": setBgColor("bg-green-500"); break;
                case "electric": setBgColor("bg-yellow-300"); break;
                case "psychic": setBgColor("bg-pink-400"); break;
                case "ice": setBgColor("bg-sky-100"); break;
                case "dragon": setBgColor("bg-sky-700"); break;
                case "dark": setBgColor("bg-gray-900"); break;
                case "fairy": setBgColor("bg-purple-300"); break;
                default: setBgColor("bg-white"); break;
            }
        }
    }, [color]);

    return (
        <Link to={`/pokemons/${name}`} onClick={() => dispatch(addUrl(`/pokemons/${name}`))}>
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.25, ease: 'easeOut' }}
                whileHover={{ scale: 1.1 }}
                viewport={{ once: false, amount: 0.3 }}
                className={`border rounded-lg shadow-md font-mono min-h-44  max-h-44 p-4 mb-4 xs:min-w-48  xs:max-w-48 w-full flex flex-col items-center text-center space-y-2 flex-grow ${bgColor}`}
            >

            <h2 className="text-lg font-semibold capitalize">{name}</h2>

                <img
                    src={src}
                    alt="data not found"
                    className="capitalize font-bold text-2xl w-24 h-24 object-contain hover:animate-spin"
                />
            </motion.div>
        </Link>
    );
};

export default PokemonCard;
